export default __webpack_public_path__ + "static/media/Jamie.c857dfb4.jpg";